import { PriceWrapper } from "Components/InsuranceDetailsCard";
import { NumberValue, VALUE_TYPE } from "Components/NumberValue";
import { ThemedSpinner } from "Components/Themes/components/ThemedSpinner";
import React from "react";

interface Props {
  shortTermProduct?: boolean;
  price: number;
  priceIsLoading?: boolean;
}

export const CoverageCardPrice = ({
  shortTermProduct,
  price,
  priceIsLoading,
}: Props): React.ReactElement => {
  const paymentType = shortTermProduct ? VALUE_TYPE.NOK : VALUE_TYPE.NOK_MONTH;
  return (
    <PriceWrapper>
      {priceIsLoading ? (
        <ThemedSpinner black />
      ) : (
        <p>
          <NumberValue
            value={price}
            type={paymentType}
            boldValue
            boldType
            largeValue
          />
        </p>
      )}
    </PriceWrapper>
  );
};
